

export const RegistrationClosed = () => {
  return (
    <>
      {/* <div className="py-3 w-[90%] flex justify-end md:flex md:justify-end mx-auto ">
        <button
          className="text-md bg-sky-300 rounded-xl px-3 py-2 flex gap-1"
          onClick={() => (window.location.href = "/")}
        >
          <ChevronLeft />
          Back
        </button>
      </div> */}
      <div className="text-black text-center space-y-10 h-[52dvh] flex flex-col justify-center p-3 max-w-5xl mx-auto">
        <div className="text-2xl font-bold text-[#BF0808] lg:text-4xl uppercase">
          <h1>
            certification training programme registration is completed for
            january 2026 batch.
          </h1>
        </div>
        <div>
          <h3 className="text-center font-bold text-xl uppercase text-[#BF0808]">fot next batch contact: </h3>
          <a href="mailto:nhwm.oh@gmail.com" className="text-blue-500 text-xl">nhwm.info@gmail.com</a>
        </div>
      </div>
    </>
  );
};
